import LandPage from './LandPage.container'
export default LandPage
